import { default as passenger } from "features/Parent/EditChildDetails/reducers";
import { reducers as network } from "components/NetworkChecker";

export default {
  // add reducers that should be initially loaded by the store here
  passenger,
  network,
};
